import { createRouteRef } from '@backstage/core-plugin-api';

export const csitLandingPageRouteRef = createRouteRef({
  id: 'integration-toolkit',
});
